import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApiService } from '../../services/api.service';
import { Definizione } from '../../shared/interface';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';

@Component({
  selector: 'app-abbecedario',
  templateUrl: './abbecedario.component.html',
  styleUrl: './abbecedario.component.css',
  encapsulation: ViewEncapsulation.None
})
export class AbbecedarioComponent implements OnInit, OnDestroy {

  constructor(
    private apiService: ApiService,
    private route: ActivatedRoute,
    private viewportScroller: ViewportScroller,
  ) { }

  definizioni: Definizione[] = []
  definizioni_raggruppate: { alfabeto: string, elementi: Definizione[] }[] = []
  definizioni_filtrate: Definizione[] = [];

  private fragmentSub?: Subscription;

  ngOnInit(): void {
    this.getData();
    this.fragmentSub = this.route.fragment.subscribe((fragment) => {
      if (fragment && this.definizioni_raggruppate.length) {
        this.scrollToFragment(fragment);
      }
    });
  }

  ngOnDestroy(): void {
    this.fragmentSub?.unsubscribe();
  }

  getData() {

    this.apiService.getDefinizioni().subscribe({
      next: (data) => this.definizioni = [...data],
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
      complete: () => {

        // Primo passo: raggruppare per alfabeto
        const raggruppatoPerAlfabeto = this.definizioni.reduce((acc: any, obj) => {
          const key = obj.alfabeto;
          if (!acc[key]) {
            acc[key] = [];
          }
          acc[key].push(obj);
          return acc;
        }, {});

        // Secondo passo: convertire l'oggetto raggruppato in un array di oggetti
        this.definizioni_raggruppate = Object.keys(raggruppatoPerAlfabeto).map(key => {
          return {
            alfabeto: key,
            elementi: raggruppatoPerAlfabeto[key]
          };
        });

        // Gli id esistono solo dopo il render: scroll all'ancora dell'URL
        this.scrollToFragment(this.route.snapshot.fragment);
      }
    })
  }

  private scrollToFragment(fragment: string | null) {
    if (!fragment) return;
    setTimeout(() => this.viewportScroller.scrollToAnchor(fragment), 0);
  }

  onFilterDefinizioni(event: AutoCompleteCompleteEvent) {

    let filtered: Definizione[] = [];
    let query = event.query;

    for (let i = 0; i < (this.definizioni).length; i++) {

      let definizione = (this.definizioni)[i];
      if (definizione.titolo.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(definizione);
      }
    }

    this.definizioni_filtrate = filtered;
  }

  onSelectDefinizione(event: any) {

    let definizioni = [event.value]

    // Primo passo: raggruppare per alfabeto
    const raggruppatoPerAlfabeto = definizioni.reduce((acc: any, obj) => {
      const key = obj.alfabeto;
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(obj);
      return acc;
    }, {});

    // Secondo passo: convertire l'oggetto raggruppato in un array di oggetti
    this.definizioni_raggruppate = Object.keys(raggruppatoPerAlfabeto).map(key => {
      return {
        alfabeto: key,
        elementi: raggruppatoPerAlfabeto[key]
      };
    });
  }
}
